import { useTranslation } from '@cobliteam/i18n';

export const LoadingGrid = () => {
  const { t } = useTranslation('drivers');
  return (
    <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4' aria-busy='true' aria-label={t('face_id.selector.loading')}>
      {Array.from({ length: 16 }).map((_, i) => (
        <div key={i} className='size-[200px] animate-pulse rounded-lg bg-gray-3' />
      ))}
    </div>
  );
};

export default LoadingGrid;
